import api from '../index'

export type ModulePermissionType = 'action' | 'data'

export interface ModulePermissionMenu {
  id: number
  module_id: number
  name: string
  path?: string | null
  module?: {
    id: number
    name: string
    path: string
    access_mode: 'system' | 'entitlement'
  } | null
}

export interface ModulePermission {
  id: number
  module_menu_id: number
  code: string
  name: string
  type: ModulePermissionType
  default_enabled?: 0 | 1
  status: 0 | 1
  sort?: number
  description?: string
  menu?: ModulePermissionMenu | null
}

export interface ModulePermissionListParams {
  module_id?: number
  module_menu_id?: number
  type?: ModulePermissionType
  status?: 0 | 1
}

export interface ModulePermissionFormData {
  module_menu_id: number
  code: string
  name: string
  type: ModulePermissionType
  default_enabled?: 0 | 1
  status?: 0 | 1
  sort?: number
  description?: string
}

export default {
  list: (params?: ModulePermissionListParams) => api.get('module/menu/permission/list', { params }),
  add: (data: ModulePermissionFormData) => api.post('module/menu/permission/add', data),
  update: (id: number, data: ModulePermissionFormData) => api.put(`module/menu/permission/edit/${id}`, data),
  delete: (id: number) => api.delete(`module/menu/permission/del/${id}`),
}
